var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.96 155.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-bass{fill:#ff3b83;}.cls-2-bass{fill:#ffc300;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icone_Resume_new",
    "data-name": "Icone Resume new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    "data-name": "Livello 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bass",
    d: "M114.64,155.67H13.32A13.33,13.33,0,0,1,0,142.36v-129A13.33,13.33,0,0,1,13.32,0H114.64A13.34,13.34,0,0,1,128,13.32v129A13.33,13.33,0,0,1,114.64,155.67ZM13.32,5.12a8.21,8.21,0,0,0-8.2,8.2v129a8.21,8.21,0,0,0,8.2,8.19H114.64a8.21,8.21,0,0,0,8.2-8.19v-129a8.21,8.21,0,0,0-8.2-8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bass",
    d: "M105.37,140.31H22.64A7.26,7.26,0,0,1,15.42,133V22.64a7.28,7.28,0,0,1,7.27-7.27h82.68a7.28,7.28,0,0,1,7.27,7.27V133A7.29,7.29,0,0,1,105.37,140.31ZM22.69,20.49a2.13,2.13,0,0,0-2.15,2.15V133a2.12,2.12,0,0,0,2.1,2.15h82.73a2.13,2.13,0,0,0,2.15-2.15V22.64a2.13,2.13,0,0,0-2.15-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bass",
    d: "M64.75,128.62A29.15,29.15,0,1,1,93.89,99.48,29.18,29.18,0,0,1,64.75,128.62Zm0-53.16a24,24,0,1,0,24,24A24,24,0,0,0,64.75,75.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bass",
    d: "M64.75,113.62A14.14,14.14,0,1,1,78.89,99.48,14.16,14.16,0,0,1,64.75,113.62Zm0-23.15a9,9,0,1,0,9,9A9,9,0,0,0,64.75,90.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bass",
    d: "M64.75,63A17.52,17.52,0,1,1,82.27,45.49,17.54,17.54,0,0,1,64.75,63Zm0-29.92a12.4,12.4,0,1,0,12.39,12.4A12.41,12.41,0,0,0,64.75,33.09Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBass);
export default __webpack_public_path__ + "static/media/home-bass.6de2c40638d162bce8683cc30dbb0c4e.svg";
export { ForwardRef as ReactComponent };